// import * as React from 'react'
import React, { useEffect, useState } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { useSearchParams } from "react-router-dom";
import Helper from 'src/support/Helper';
import { Pagination } from 'src/reusable/global';
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/support/Constants';
import ContentTabCommonSorting from "src/pages/HomePageContent/ContentTabs/ContentTabCommonSorting";

const EventTab = () => {
    const [list, setList] = useState({});
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ }, { get_home_page_content }] = useHomePageContentStore();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: 'Relevance'
    });
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const { homePageAllTabs } = Constants;

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall(firstServerCall);
            await setFirstServerCall(false);
        };
        getList();
    }, []);
    
    useEffect(() => {
        const getList = async () => {
            setTimeout(async () => {
                await fetchAPiCall();
            }, 500);
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall(firstServerCall)
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit, listObj.sortBy]);

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    const fetchAPiCall = async () => {
        __set("CONTENT_API_CALL");
        const search_keyword = searchParams.get('search');
        const data = await get_home_page_content({
            pageNumber: firstServerCall ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.EVENT.contentType,
        });
        if (data[homePageAllTabs.EVENT.contentType].totalCount > 0) {
            const total = data[homePageAllTabs.EVENT.contentType].totalCount;
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) });
            setList(data[homePageAllTabs.EVENT.contentType].webContentView);
        } else {
            setList([]);
        }
        __remove("CONTENT_API_CALL");
    };

    const onFilter = (e) => {
        setListObj({ ...listObj, sortBy: e.target.value });
    }
    return (
        <div id="contentEventContent" className="tab-pane fade active in">
            <div className='event-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>
                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.EVENT.tabHeader} dataLength={list.length} />
                            <hr />
                            <div className='position-relative'>
                                <div>
                                    {__check(['CONTENT_API_CALL'], { overlay: true }).render}
                                </div>
                                <div className='all-content-body'>
                                    {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                        list.map((v, i) => (
                                            <React.Fragment key={i}>
                                                <div className='all-content-body-item'>
                                                    <div className='bs5 row m-0'>
                                                        <div className='col-lg-12'>
                                                            <div className='font-16 text-blue2 font-bold mb-1'><a href={v['url']} target='_blank'>{v['name']}</a></div>
                                                            <div className='ellipses' title="">
                                                                {v['longDescription']}
                                                            </div>
                                                            {v['longDescription'] !== undefined &&
                                                                v['longDescription'] !== null &&
                                                                v['longDescription'] !== '' &&
                                                                v['longDescription'].length > 140 &&
                                                                <a href={v['url']} className="text-blue2 d-block" target='_blank'>Read More</a>
                                                            }
                                                            <div className="date-location-box mt-2">
                                                                <div className="date-location-item">
                                                                    <b>Date:&nbsp;</b> {Helper.getLongDateFormat(v['avnDate'])}
                                                                </div> <br />
                                                                <div className="date-location-item">
                                                                    <b>Location:&nbsp;</b> {v['avnLocation']}
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    <hr />
                                                </div>
                                            </React.Fragment>
                                        ))
                                    }
                                    {firstServerCall === false && (list === undefined || list === null || Object.entries(list).length === 0) &&
                                        searchParams.get('search') !== undefined && searchParams.get('search') !== null && searchParams.get('search') !== '' &&
                                        <NoResultContent message={'No Events Found for <b>"' + searchParams.get('search') + '"</b>'} />
                                    }
                                </div>
                                {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                    <div className="pagination-row">
                                        <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 tab-sidebar'>
                        <div className='m-b-20' id="espotImg">
                        </div>
                        <div className='newsletter m-b-20'>
                            <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
                            <p className='m-b-15 text-black'>Subscribe for online delivery</p>
                            <a className='bs5 btn btn-primary w135'>Sign up now</a>
                        </div>
                        <div className='looking-for'>
                            <div className='looking-title font-24 font-bold font-apercu mb-2'>Looking for Products?</div>
                            <a href={void (0)} className="text-blue2 d-block">View Our New Product Introductions</a>
                            <a href={void (0)} className="text-blue2 d-block"> View Our Current Promotions</a>
                            <hr className='my-2' />
                            <div>
                                Today, we can design, make, supply and
                                deliver for customers of every size in every
                                corner of the world - whether your product
                                is still a notion on a napkin, in mass
                                production or at any point in between.
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default EventTab